import { render } from "./PasswordDialog.vue?vue&type=template&id=83f9bed8&scoped=true"
import script from "./PasswordDialog.vue?vue&type=script&lang=js"
export * from "./PasswordDialog.vue?vue&type=script&lang=js"

import "./PasswordDialog.vue?vue&type=style&index=0&id=83f9bed8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f9bed8"]])

export default __exports__